import { useTheme } from '@veneer/theme';
export var useBackground = background => {
  var {
    mode
  } = useTheme();
  var darkMode = ['dark', 'contrast'].includes(mode);
  return background === 'auto' ? darkMode ? 'onDark' : 'onLight' : background === 'dark' ? 'onDark' : 'onLight';
};